import { render } from "./NoticiaCategories.vue?vue&type=template&id=54c9cf2c"
import script from "./NoticiaCategories.vue?vue&type=script&lang=js"
export * from "./NoticiaCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__